@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">New York</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 2; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <div class="has-axis-error">
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        @if (baseRules.SplitMinLimits_DropDown?.includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[4].label }} </label>
              <div id="splitminlimits_25k_50k-pdffield-new-york">{{ controls[4].data[0].name }}</div>
            </div>
          </div>
        }
        @if (baseRules.CombinedSingleMinLimit_DropDown?.includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[5].label }} </label>
              <div id="combinedsingleminlimit_50k-pdffield-new-york">{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">New York</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules?.SplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[4].label }} </label>
          <div>{{ controls[4].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[5].label }} </label>
          <div>{{ controls[5].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[6].label }} </label>
          <div>{{ controls[6].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
